import React from 'react'

type Props = {
    option      : any
    hideIcon?   : boolean

    onClick     : {(option:any, e:any):void}
}

export enum MoreButtonOptionType {
    // dont start with 0 !!!
    SAVE_AS_TEMPLATE    = 1,
    LOAD_FROM_TEMPLATE  = 2,
    EXPORT_CSV          = 3,
    EXPORT_PDF          = 4,
    EDIT_VIEW           = 5,
    DELETE_VIEW         = 6,
    REMOVE_ALL_COLUMNS  = 7,
    PRINT               = 8,
    RESET_COLUMNS_WIDTH = 9,
    SHORTCUTS           = 10,
    HELP                = 11,
    RESET_VIEW          = 12,
    REMOVE_ALL_WIDGETS  = 13
}

export default function MoreMenuStandardOption(props:Props) {

    const onClick = (e:any) => {
        if (!props.option.disabled) props.onClick(props.option,e)
    }

    let label = '', icon = '';

    switch (props.option.type) {
        case MoreButtonOptionType.SAVE_AS_TEMPLATE:
            label   = 'Save as template'
            icon    = 'i5-save'
            break

        case MoreButtonOptionType.LOAD_FROM_TEMPLATE:
            label   = 'Load from template'
            icon    = 'i5-load'
            // icon    = 'i5-folder-open'
            break

        case MoreButtonOptionType.EXPORT_PDF:
            label   = 'Export to PDF'
            icon    = 'i5-pdf'
            break

        case MoreButtonOptionType.EXPORT_CSV:
            label   = 'Export to CSV'
            icon    = 'i5-csv'
            break

        case MoreButtonOptionType.DELETE_VIEW:
        case 'delete-view'          :
            label = 'Delete view';            icon = 'i5-trash-alt'; break;

        case MoreButtonOptionType.EDIT_VIEW:
        case 'edit-view':
            label   = 'Edit view'
            icon    = 'i5-pen'
            break

        case MoreButtonOptionType.REMOVE_ALL_COLUMNS:
            label   = 'Remove all columns'
            icon    = 'i5-none'
            break

        case MoreButtonOptionType.RESET_COLUMNS_WIDTH:
        case 'reset-columns-width'  :
            label = 'Reset columns width';    icon = 'i5-reset-columns';
            break;

        case MoreButtonOptionType.RESET_VIEW:
            label = 'Reset view';
            icon = 'i5-reset';
            break;

        case MoreButtonOptionType.REMOVE_ALL_WIDGETS:
            label = 'Remove all widgets';
            icon = 'i5-trash-alt';
            break;

        case 'import-csv'           : label = 'Import from CSV';        icon = 'i5-import-from'; break;
        case 'export-csv'           : label = 'Export to CSV';          icon = 'i5-csv'; break;
        case 'export-png'           : label = 'Export to PNG ';         icon = 'i5-file-image'; break;

        case MoreButtonOptionType.PRINT:
        case 'print'                :
            label = 'Print';                  icon = 'i5-print';
            break;

        case MoreButtonOptionType.SHORTCUTS :
            label   = 'Shortcuts'
            icon    = 'i5-keyboard'
            break

        case MoreButtonOptionType.HELP      :
        case 'help'                         :
            label   = 'Help'
            icon    = 'i5-help'
            break

        case 'video-tutorial'       : label = 'Video tutorial';         icon = 'i5-youtube'; break;
        case 'tour'                 : label = 'Quick tour';             icon = 'i5-presentation'; break;

        case 'delete'               : label = 'Delete';                 icon = 'i5-trash-alt'; break;
        case 'rename'               : label = 'Rename';                 icon = 'i5-pen'; break;
        case 'move'                 : label = 'Move';                   icon = 'i5-move'; break;
        case 'export-pdf-custom'    : label = 'Export to PDF';          icon = 'i5-pdf'; break;

        case 'pin'                  : label = 'Pin to home menu';       icon = 'i5-pin'; break;
        case 'unpin'                : label = 'Unpin from home menu';   icon = 'i5-pin-full'; break;

        default:
            console.log("#4oidashdasd unknown type", props.option)
            break
    }

    const classes = Classes("option", "with-icon", {
        disabled: props.option.disabled
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className={Classes('ico', {[icon]: !props.hideIcon})}/>
            <div className={Classes("label",{disabled: props.option.disabled})}>
                {label}
            </div>

        </div>
    )
}
